import React, { useEffect, useState } from "react";
import { SortArrow } from "../../../shared/svg/sort-arrow";
import CustomCheckBox from "../customCheckBox/customCheckBox";
import { TableCellType } from "./table";

interface TableHeaderProps {
  sortedTableHeaders: {
    key: string;
    label: string;
    width: number;
    sortable: boolean;
    subKey?: string;
    type?: string;
  }[];
  tableWidth: number;
  onSortTableData: (key: string, subKey?: string, type?: string) => void;
  onSelectAll?: () => void;
  isCheckboxSelected?: boolean;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  sortedTableHeaders,
  tableWidth,
  onSortTableData,
  onSelectAll,
  isCheckboxSelected,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(isCheckboxSelected || false);
  }, [isCheckboxSelected]);

  return (
    <thead>
      <tr style={{ display: "flex", width: "100%" }}>
        {sortedTableHeaders.map((header, index) => (
          <td
            key={index}
            style={{
              width: `${header.width}%`,
            }}
          >
            <div
              className="header-details"
              onClick={
                header.type === TableCellType.CHECKBOX ? onSelectAll : undefined
              }
            >
              <div className="header-details--text truncate">
                {header.type === TableCellType.CHECKBOX ? (
                  <div className="header-details--checkbox flex items-center justify-center">
                    <CustomCheckBox
                      id={header.key}
                      label={""}
                      isChecked={isChecked}
                      onCheckBoxValueChange={() => setIsChecked(!isChecked)}
                      removeGap={true}
                    />
                  </div>
                ) : (
                  header.label
                )}
              </div>
              <div className="header-details--icon">
                {header.sortable && (
                  <SortArrow
                    onClick={() =>
                      onSortTableData(header.key, header.subKey, header.type)
                    }
                  />
                )}
              </div>
            </div>
          </td>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
